const default_state = () => {
    return {
        audience_id: null,
        show_modal: false,

        description: '',

        step: 1,
        step_status: true,
        activation: [],
        activation_analyses: [],

        partners: [],
        partner: {
            id: null
        },
        pricing_models: [],
        pricing_models_data: [],
        pricing_model: '',

        limits: {
            total: 0,
            freq: {
                status: false,
                min: 0,
                max: 1,
                range: [0, 0],
            },
            distance: {
                status: false,
                min: 0,
                max: 0,
                range: 161,
            }
        },

        data_delivery: {
            audience: {
                inputs: [],
                compression: null,
                service_account: null,
                service_account_file: null
            },
            datastreams: [
                {
                    id: null,
                    name: null,
                    status: false,
                    inputs: [],
                    compression: null,
                    service_account: null
                }
            ]
        },

        audience: 0,
        price: 0,

        datastreams: {
            selected: [],
            all: [],
        },

        datastreams_loading_completed: false,

        notification: true,
    }
}

export default default_state